module.exports = __webpack_public_path__ + "assets/img/sabc_social_facebook.webp?4a448c574ff4bdedb20cdb235aa981d3";